<script>
  import t from '#lib/i18n.svelte.js';
  import AvatarInitials from '#lib/AvatarInitials.svelte';
  import Image from './Image.svelte';
  let {
    /** @type {object | undefined } image of the user */
    avatar = undefined,
    /** @type {string | undefined } name of the user */
    name = undefined,
    /** @type {boolean} animate the avatar */
    animate = false,
    class: css_class = ''
  } = $props()
</script>

{#if avatar}
  <Image
    {...avatar}
    class='avatar avatar-image border-1 border-round icon {css_class}'
    alt={t('avatar')}
    aspect_ratio='1 / 1'
    width={32}
    height={32}
    display_width={32}
    display_height={32}
    fit_to_frame={false}
    sizes="32px"
  />
{:else}
  <AvatarInitials name={name} {animate} class={css_class} />
{/if}